import {
  type ApolloError,
  useQuery,
  type WatchQueryFetchPolicy,
} from '@apollo/client'
import { ALL_TAGS_QUERY } from '@/modules/common/queries'
import type {
  AllTagsQueryResponse,
  TagNode,
} from '@/modules/common/types'

interface Options {
  fetchPolicy?: WatchQueryFetchPolicy
  nextFetchPolicy?: WatchQueryFetchPolicy
  onError?: (error: ApolloError) => void
}

/**
 * Fetch all tags with ``scope: ISSUE`` and return them as a flat list.
 *
 * Centralises the ``allTags { edges { node } }`` unwrap so callers (settings
 * page, issue form picker, list filter) read the same shape.
 */
export function useAllIssueTags(options: Options = {}) {
  const { data, loading, refetch } = useQuery<AllTagsQueryResponse>(
    ALL_TAGS_QUERY,
    {
      variables: { scope: 'ISSUE' },
      fetchPolicy: options.fetchPolicy,
      nextFetchPolicy: options.nextFetchPolicy,
      onError: options.onError,
    }
  )

  const tags: TagNode[] = data?.allTags.edges.map(e => e.node) ?? []
  return { tags, loading, refetch }
}
